export const VerticalViewDetailsButton = ({ serviceUrl, isAssociation }) => {
  return (
    <a href={serviceUrl} target={isAssociation ? '_blank' : ''} className="vertical-view-details-button">
      View Details
    </a>
  );
};
